import iBS03R_ResultType from '../model/iBS03R_ResultType';
import SensorResultTable from './SensorResultTable';

type propsType = {
    sensorlogs: iBS03R_ResultType[]
}

const COLUMNS = ["no", "app_id", "manufacturer_id", "model", "battery", "button", "distance", "macaddress", "rssi", "detected", "arrived"];

const SensorLog_iBS03R_Result = (props: propsType) => (
    <SensorResultTable rows={props.sensorlogs} columnKeys={COLUMNS} />
);

export default SensorLog_iBS03R_Result;
